var React = require('react');

function Windows (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 22.422L10.6563 23.8907V13.7189H0V22.422Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M0 12.4063H10.6563V2.1095L0 3.57816V12.4063Z","fill":"currentColor","key":1}),React.createElement("path",{"d":"M11.8281 24.0471L25.9999 26V13.7189V13.7188H11.8281V24.0471Z","fill":"currentColor","key":2}),React.createElement("path",{"d":"M11.8284 1.95311V12.4063H26V0L11.8284 1.95311Z","fill":"currentColor","key":3})]);
}

Windows.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 25 26","fill":"none"};

module.exports = Windows;

Windows.default = Windows;
